import styled from 'styled-components';

import { buttonMixin } from '~src/styles/mixin';

export const Submit = styled.button`
  ${buttonMixin}
  max-width: 15.625em;
  margin-left: auto;
  margin-bottom: 1em;
`;

export const FormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: transparent;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 5em;
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  max-width: 24em;
  width: 100%;

  &:first-child {
    height: 100%;
    margin-right: 2.5em;
  }
`;

export const InputBox = styled.div`
  width: 100%;
`;

export const TextareaBox = styled.div`
  margin-top: 0.7em;
`;
